import { SVGProps, cloneElement } from "react";

import { AssetsMarkBrandV3 } from "./logos-v3/assets-v3-mark-brand";
import { AtlassianLogoBrandV3 } from "./logos-v3/atlassian-v3-logo-brand";
import { AtlassianMarkBrandV3 } from "./logos-v3/atlassian-v3-mark-brand";
import { BambooMarkBrandV3 } from "./logos-v3/bamboo-v3-mark-brand";
import { BitbucketLogoBrandV3 } from "./logos-v3/bitbucket-v3-logo-brand";
import { BitbucketMarkBrandV3 } from "./logos-v3/bitbucket-v3-mark-brand";
import { CollectionServiceLogoBrandV3 } from "./logos-v3/collection-service-v3-logo-brand";
import { CollectionSoftwareLogoBrandV3 } from "./logos-v3/collection-software-v3-logo-brand";
import { CollectionStrategyLogoBrandV3 } from "./logos-v3/collection-strategy-v3-logo-brand";
import { CollectionTeamworkLogoBrandV3 } from "./logos-v3/collection-teamwork-v3-logo-brand";
import { CompassLogoBrandV3 } from "./logos-v3/compass-v3-logo-brand";
import { CompassMarkBrandV3 } from "./logos-v3/compass-v3-mark-brand";
import { ConfluenceLogoBrandV3 } from "./logos-v3/confluence-v3-logo-brand";
import { ConfluenceMarkBrandV3 } from "./logos-v3/confluence-v3-mark-brand";
import { CustomerServiceManagementMarkBrandV3 } from "./logos-v3/customer-service-management-v3-mark-brand";
import { DxMarkBrandV3 } from "./logos-v3/dx-v3-mark-brand";
import { FocusMarkBrandV3 } from "./logos-v3/focus-v3-mark-brand";
import { GuardLogoBrandV3 } from "./logos-v3/guard-v3-logo-brand";
import { GuardMarkBrandV3 } from "./logos-v3/guard-v3-mark-brand";
import { JiraAlignMarkBrandV3 } from "./logos-v3/jira-align-v3-mark-brand";
import { JiraProductDiscoveryLogoBrandV3 } from "./logos-v3/jira-product-discovery-v3-logo-brand";
import { JiraProductDiscoveryMarkBrandV3 } from "./logos-v3/jira-product-discovery-v3-mark-brand";
import { JiraServiceManagementLogoBrandV3 } from "./logos-v3/jira-service-management-v3-logo-brand";
import { JiraServiceManagementMarkBrandV3 } from "./logos-v3/jira-service-management-v3-mark-brand";
import { JiraLogoBrandV3 } from "./logos-v3/jira-v3-logo-brand";
import { JiraMarkBrandV3 } from "./logos-v3/jira-v3-mark-brand";
import { LoomCharlieLogoBrandV3 } from "./logos-v3/loom-charlie-v3-logo-brand";
import { LoomCircularLogoBrandV3 } from "./logos-v3/loom-circular-v3-logo-brand";
import { LoomMarkBrandV3 } from "./logos-v3/loom-v3-mark-brand";
import { OpsgenieMarkBrandV3 } from "./logos-v3/opsgenie-v3-mark-brand";
import { PipelinesMarkBrandV3 } from "./logos-v3/pipelines-v3-mark-brand";
import { RovoDevLogoBrandV3 } from "./logos-v3/rovo-dev-v3-logo-brand";
import { RovoDevMarkBrandV3 } from "./logos-v3/rovo-dev-v3-mark-brand";
import { RovoLogoBrandV3 } from "./logos-v3/rovo-v3-logo-brand";
import { RovoMarkBrandV3 } from "./logos-v3/rovo-v3-mark-brand";
import { SourcetreeLogoBrandV3 } from "./logos-v3/sourcetree-v3-logo-brand";
import { SourcetreeMarkBrandV3 } from "./logos-v3/sourcetree-v3-mark-brand";
import { StatuspageLogoBrandV3 } from "./logos-v3/statuspage-v3-logo-brand";
import { StatuspageMarkBrandV3 } from "./logos-v3/statuspage-v3-mark-brand";
import { TalentMarkBrandV3 } from "./logos-v3/talent-v3-mark-brand";
import { TrelloLogoBrandV3 } from "./logos-v3/trello-v3-logo-brand";
import { TrelloMarkBrandV3 } from "./logos-v3/trello-v3-mark-brand";

export type LogoBrandV3 =
    | "atlassian"
    | "assets"
    | "bamboo"
    | "bitbucket"
    | "collectionteamwork"
    | "collectionservice"
    | "collectionsoftware"
    | "collectionstrategy"
    | "compass"
    | "confluence"
    | "customerservicemanagement"
    | "dx"
    | "pipelines"
    | "focus"
    | "guard"
    | "jira"
    | "jiraalign"
    | "jiraproductdiscovery"
    | "jiraservicemanagement"
    | "loom"
    | "loomcircular"
    | "opsgenie"
    | "rovo"
    | "rovodev"
    | "sourcetree"
    | "statuspage"
    | "talent"
    | "trello";

export interface LogoPropsV3
    extends Pick<SVGProps<SVGSVGElement>, "height" | "width"> {
    type: "mark" | "logo";
    appearance: "brand";
    brand: LogoBrandV3;
    lightMode?: boolean;
}

type LogoAppearance = {
    brand: JSX.Element;
};

type LogoType = {
    mark: LogoAppearance;
    logo?: LogoAppearance;
};

type Logos = { [key in LogoBrandV3]: LogoType };

const Logos: Logos = {
    atlassian: {
        mark: {
            brand: <AtlassianMarkBrandV3 />
        },
        logo: {
            brand: <AtlassianLogoBrandV3 />
        }
    },
    assets: {
        mark: {
            brand: <AssetsMarkBrandV3 />
        }
    },
    bamboo: {
        mark: {
            brand: <BambooMarkBrandV3 />
        }
    },
    bitbucket: {
        mark: {
            brand: <BitbucketMarkBrandV3 />
        },
        logo: {
            brand: <BitbucketLogoBrandV3 />
        }
    },
    collectionteamwork: {
        mark: {
            brand: <CollectionTeamworkLogoBrandV3 />
        }
    },
    collectionservice: {
        mark: {
            brand: <CollectionServiceLogoBrandV3 />
        }
    },
    collectionsoftware: {
        mark: {
            brand: <CollectionSoftwareLogoBrandV3 />
        }
    },
    collectionstrategy: {
        mark: {
            brand: <CollectionStrategyLogoBrandV3 />
        }
    },
    compass: {
        mark: {
            brand: <CompassMarkBrandV3 />
        },
        logo: {
            brand: <CompassLogoBrandV3 />
        }
    },
    confluence: {
        mark: {
            brand: <ConfluenceMarkBrandV3 />
        },
        logo: {
            brand: <ConfluenceLogoBrandV3 />
        }
    },
    customerservicemanagement: {
        mark: {
            brand: <CustomerServiceManagementMarkBrandV3 />
        }
    },
    dx: {
        mark: {
            brand: <DxMarkBrandV3 />
        }
    },
    focus: {
        mark: {
            brand: <FocusMarkBrandV3 />
        }
    },
    guard: {
        mark: {
            brand: <GuardMarkBrandV3 />
        },
        logo: {
            brand: <GuardLogoBrandV3 />
        }
    },
    jira: {
        mark: {
            brand: <JiraMarkBrandV3 />
        },
        logo: {
            brand: <JiraLogoBrandV3 />
        }
    },
    jiraalign: {
        mark: {
            brand: <JiraAlignMarkBrandV3 />
        }
    },
    jiraproductdiscovery: {
        mark: {
            brand: <JiraProductDiscoveryMarkBrandV3 />
        },
        logo: {
            brand: <JiraProductDiscoveryLogoBrandV3 />
        }
    },
    jiraservicemanagement: {
        mark: {
            brand: <JiraServiceManagementMarkBrandV3 />
        },
        logo: {
            brand: <JiraServiceManagementLogoBrandV3 />
        }
    },
    loom: {
        mark: {
            brand: <LoomMarkBrandV3 />
        },
        logo: {
            brand: <LoomCharlieLogoBrandV3 />
        }
    },
    loomcircular: {
        mark: {
            brand: <LoomMarkBrandV3 />
        },
        logo: {
            brand: <LoomCircularLogoBrandV3 />
        }
    },
    opsgenie: {
        mark: {
            brand: <OpsgenieMarkBrandV3 />
        }
    },
    pipelines: {
        mark: {
            brand: <PipelinesMarkBrandV3 />
        }
    },
    rovo: {
        mark: {
            brand: <RovoMarkBrandV3 />
        },
        logo: {
            brand: <RovoLogoBrandV3 />
        }
    },
    rovodev: {
        mark: {
            brand: <RovoDevMarkBrandV3 />
        },
        logo: {
            brand: <RovoDevLogoBrandV3 />
        }
    },
    sourcetree: {
        mark: {
            brand: <SourcetreeMarkBrandV3 />
        },
        logo: {
            brand: <SourcetreeLogoBrandV3 />
        }
    },
    statuspage: {
        mark: {
            brand: <StatuspageMarkBrandV3 />
        },
        logo: {
            brand: <StatuspageLogoBrandV3 />
        }
    },
    talent: {
        mark: {
            brand: <TalentMarkBrandV3 />
        }
    },
    trello: {
        mark: {
            brand: <TrelloMarkBrandV3 />
        },
        logo: {
            brand: <TrelloLogoBrandV3 />
        }
    }
};

export const LogoV3 = ({
    brand,
    type,
    appearance,
    width,
    height,
    lightMode
}: LogoPropsV3) => {
    const logo = Logos[brand]?.[type]?.[appearance];

    return logo ? cloneElement(logo, { width, height, lightMode }) : null;
};
